import React from "react";
import { useTranslation } from 'react-i18next'

const Setpapply = ({setpapplydata}) => {
  const { t, i18n } = useTranslation()
let set_listdata = setpapplydata.steps;
  return (
    <section className="cfan-step-apply registration-apply">
    <h3 className="registration-step-heading">{t('Steps_to_Register')}</h3>
        <div className="steps-data-wrapper">
                    {set_listdata.map((item, index) => (
                <div key={index} className="step-item d-flex">
                    <span>{item.serial_number}</span><p>{item.title}</p>
                </div>
            ))}
        </div>
    </section>
  );
};

export default Setpapply;